<!-- =========================================================================================
    Description: Properties panel for a node placed on a screen anchor canvas.
    Allows precise numerical editing of position, size, rotation, and scale.
========================================================================================== -->

<template>
  <div v-if="node" class="screen-anchor-properties">
    <p class="properties-title">{{ hobjectName }}</p>

    <div class="vx-row mt-2">
      <div class="vx-col w-1/2 pr-1">
        <vs-input
          type="number"
          label="X (px)"
          size="small"
          class="w-full"
          :value="node.x"
          @change="update('x', parseFloat($event.target.value))"
        />
      </div>
      <div class="vx-col w-1/2 pl-1">
        <vs-input
          type="number"
          label="Y (px)"
          size="small"
          class="w-full"
          :value="node.y"
          @change="update('y', parseFloat($event.target.value))"
        />
      </div>
    </div>

    <div class="vx-row mt-2">
      <div class="vx-col w-1/2 pr-1">
        <vs-input
          type="number"
          label="Width (px)"
          size="small"
          class="w-full"
          :value="node.width"
          @change="update('width', parseFloat($event.target.value))"
        />
      </div>
      <div class="vx-col w-1/2 pl-1">
        <vs-input
          type="number"
          label="Height (px)"
          size="small"
          class="w-full"
          :value="node.height"
          @change="update('height', parseFloat($event.target.value))"
        />
      </div>
    </div>

    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <vs-button
          size="small"
          type="flat"
          color="primary"
          @click="resetToNaturalSize"
        >Reset to Natural Size</vs-button>
      </div>
    </div>

    <div class="vx-row mt-3">
      <div class="vx-col w-full">
        <p class="config-section-title">Anchor Position</p>
        <anchor-position-picker
          :value="node.anchor_position || 'bottom-right'"
          @input="update('anchor_position', $event)"
        />
      </div>
    </div>

    <div class="vx-row mt-3">
      <div class="vx-col w-full">
        <label class="input-label">Scale ({{ node.scale }}x)</label>
        <input
          type="range"
          min="0.1"
          max="3"
          step="0.05"
          class="w-full mt-1"
          :value="node.scale"
          @input="update('scale', parseFloat($event.target.value))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AnchorPositionPicker from './AnchorPositionPicker.vue'

export default {
  name: 'ScreenAnchorObjectProperties',
  components: { AnchorPositionPicker },
  props: {
    node: {
      type: Object,
      default: null,
    },
    hobjects: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hobjectName() {
      if (!this.node) return ''
      const h = this.hobjects.find(h => h.pid === this.node.hobject_pid)
      return h ? h.name : this.node.hobject_pid
    },
    naturalWidth() {
      if (!this.node) return null
      const h = this.hobjects.find(h => h.pid === this.node.hobject_pid)
      return h ? h.width : null
    },
    naturalHeight() {
      if (!this.node) return null
      const h = this.hobjects.find(h => h.pid === this.node.hobject_pid)
      return h ? h.height : null
    },
  },
  methods: {
    update(field, value) {
      this.$emit('update-node', { ...this.node, [field]: value })
    },
    resetToNaturalSize() {
      if (this.naturalWidth && this.naturalHeight) {
        this.$emit('update-node', {
          ...this.node,
          width: this.naturalWidth,
          height: this.naturalHeight,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.screen-anchor-properties {
  padding: 8px;
  background: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #eee;
}

.properties-title {
  font-weight: 600;
  font-size: 0.85rem;
  margin: 0 0 4px 0;
  color: #2c2c2c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input-label {
  font-size: 0.75rem;
  color: #626262;
}

.config-section-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 6px 0;
}
</style>
